import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M328-120H120v-360q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-480v360H632v-296h148v-64q0-125.357-87.321-212.679Q605.357-780 480-780t-212.679 87.321Q180-605.357 180-480v64h148v296Z"
  })
}), "HeadphonesFilled");